import { PropsWithChildren } from "react";

import Menu from "./menu";
import { TopMenu } from "./top-menu";

export function Layout({
  showTopMenu = true,
  showMenu = true,
  children,
}: PropsWithChildren<{ showTopMenu?: boolean; showMenu?: boolean }>) {
  return (
    <main className="flex flex-col min-h-screen">
      {showTopMenu && <TopMenu />}
      <section className="lg:container flex flex-col grow w-full py-5">
        {children}
      </section>
      {showMenu && <Menu />}
    </main>
  );
}
